import React from "react"
import { graphql } from "gatsby"
import { SingleReviewProps } from "components/reviews/SingleReview"
import { StaticReviewProps } from "components/reviews/StaticReview"
import { FormBuilder } from "components/forms/FormBuilder"
import { BlogBanner } from "components/blog/BlogBanner/BlogBanner"
import { CTABanner } from "components/cta-banner/CTABanner"
import { GlobalFooterReviews } from "./GlobalFooterReviews"
import { ValueOf } from "_types/Utils"
import { AffiliationSliderGlobalFooter } from "components/affiliation-slider/AffiliationSliderGlobalFooter"

type StrapiComponentTypes = keyof typeof COMPONENTS

// Get the value of each key as a type separated by | (OR)
type StrapiComponents = ValueOf<typeof COMPONENTS>

type GlobalFooterComponents =
  | React.ComponentProps<StrapiComponents>
  | StaticReviewProps
  | SingleReviewProps

type GlobalFooterGeneralContent = {
  id: string
  strapi_component: string
}

type GlobalFooterContent = GlobalFooterGeneralContent & GlobalFooterComponents

interface GlobalFooterProps {
  content: GlobalFooterContent[]
  customTrackingNumber?: string
  isLandingPage?: boolean
}

const COMPONENTS = {
  "content-block.cta-banner": CTABanner,
  "content-block.footer-logo-slider": AffiliationSliderGlobalFooter,
  "forms.form": FormBuilder,
  "global-footer.global-footer-blog-banner": BlogBanner,
  "reviews.review-position": GlobalFooterReviews,
}

export const GlobalFooter = ({
  content,
  isLandingPage = false,
}: GlobalFooterProps) => {
  return (
    <>
      {content?.map((component, index) => {
        const strapiComponentType =
          component.strapi_component as StrapiComponentTypes
        if (typeof COMPONENTS[strapiComponentType] !== "undefined") {
          const Component = COMPONENTS[
            strapiComponentType
          ] as React.FunctionComponent

          const locationComponentParser =
            component.strapi_component === "forms.form"
              ? {
                  locationComponentParser: "global-footer",
                }
              : {}

          const isLandingPageComponentParser =
            component.strapi_component === "reviews.review-position" ||
            component.strapi_component === "forms.form"
              ? { isLandingPage }
              : {}

          return (
            <Component
              key={`${component.id}-${index}`}
              {...component}
              {...locationComponentParser}
              {...isLandingPageComponentParser}
            />
          )
        }
        return <p key={Math.random()}>Not yet queried</p>
      })}
    </>
  )
}

export const query = graphql`
  fragment StrapiGlobalFooterFragment on STRAPI_GLOBAL_FOOTER {
    id
    content {
      ...StrapiBlogBannerGlobalFooterFragment
      ...StrapiCTABannerFragment
      ...StrapiFormGlobalFooterFragment
      ...StrapiLogoSliderGlobalFooterFragment
      ...StrapiReviewGlobalFooterFragment
    }
  }
`
